(function ($) {

    $.fn.filemanager = function (type, options) {
        type = type || 'file';

        this.on('click', function (e) {
            var route_prefix = (options && options.prefix) ? options.prefix : '/filemanager';
            var target_input = $('#' + $(this).data('input'));
            var target_preview = $('#' + $(this).data('preview'));
            // console.log(target_preview)
            window.open(route_prefix + '?type=' + type, 'FileManager', 'width=900,height=600');
            window.SetUrl = function (items) {
                var file_path = items.map(function (item) {
                    return item.url;
                }).join(',');
                console.log('upload btn')
                // if (document.getElementById('image-preview')) {
                    // document.getElementById('image-preview').src = file_path;
                    // document.getElementById('image-preview').style.display = 'block';
                // }


                // set the value of the desired input to image url
                target_input.val('').val(file_path).trigger('change');

                // clear previous preview
                target_preview.html('');

                // set or change the preview image src
                items.forEach(function (item) {
                    target_preview.append(
                        $('<img>').css({ 'height': '13rem', 'width': '13rem' }).attr('src', item.thumb_url).attr('class', 'img-fluid shadow-sm p-2 bg-white rounded'),
                        //  remove image work
                        $(`<button type="button" class="btn btn-sm remove-img border shadow-sm border-light rounded-circle"><i class="fa fa-times"></i></button>`).after('<img>')
                    );
                });
                //  remove image work
                // console.log("working right here");

                // trigger change event
                target_preview.trigger('change');
            };
            return false;
        });
    }

})(jQuery);
